import { HeadingTheme } from '@/components/Heading/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Heading = GenericSlot({ as: 'h2', theme: HeadingTheme });
